const state = {
  locale: 'ko'
};

const mutations = {
  setLocale(state, locale = 'ko') {
    state.locale = locale;
  }
};

const getters = {
  getLocale: (state) => state.locale
};

export default {
  namespaced: true,
  state,
  mutations,
  getters
};
